import { render } from "./ButtonExternalLink.vue?vue&type=template&id=a0fef0ce&scoped=true&ts=true"
import script from "./ButtonExternalLink.vue?vue&type=script&lang=ts"
export * from "./ButtonExternalLink.vue?vue&type=script&lang=ts"

import "./ButtonExternalLink.vue?vue&type=style&index=0&id=a0fef0ce&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fef0ce"]])

export default __exports__